import { themeSeparator } from "./constants";

export const createThemeMap = ({ themes }) => {
    const entries = Object.entries(themes);

    const variablesInfo = entries.map(([k, v]) => {
        const [themeName, ...varibaleNameParts] = k.split(themeSeparator);
        return {
            themeName,
            variableName: varibaleNameParts.join(themeSeparator),
            value: v,
        };
    });

    return variablesInfo.reduce((agg, cur) => {
        const theme = agg[cur.themeName] ?? {};
        const updatedTheme = {
            ...theme,
            [cur.variableName]: cur.value,
        };

        return {
            ...agg,
            [cur.themeName]: updatedTheme,
        };
    }, {});
} 